$(function () {

    // Function to scroll to the first error message if it's not visible in the viewport
    window.scrollToErrorMessage = function () {

        const navigationHeight = $('.header').height();
        const errorElement = $('.error__message').first(); // Select the first error message

        if (errorElement.length > 0) {

            const errorElementOffset = errorElement.offset().top;
            const windowHeight = $(window).height();
            const fixedPixels = 130;

            // Calculate the top and bottom boundaries of the viewport
            const viewportTop = $(window).scrollTop() + navigationHeight + fixedPixels;
            const viewportBottom = viewportTop + windowHeight;

            // Check if the error element is already visible in the viewport
            if (errorElementOffset >= viewportTop && errorElementOffset <= viewportBottom) {
                return; // No need to scroll; it's already visible
            }

            // Scroll to the error element
            const scrollToPosition = errorElementOffset - navigationHeight - fixedPixels;
            $('html, body').animate({scrollTop: scrollToPosition}, 500);
        }
    };
});
